import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const WidgetMessenger: Widget = {
  type: WidgetType.messenger,
  isFrameless: true,
  title: 'Messenger',
  minSize: 4,
  defaultSize: 32,
  icon: 'Chat',
  defaultHeightType: WidgetHeightType.automatic,
  notEditable: ['height'],
  customSettings: {
    settings: {
      readonlymode: { type: WidgetSettingType.checkbox, title: 'Nur-Lesen-Modus (kein Antwortfeld)', checked: false },
      channel: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomCustomMessengerChannel' }
    },
    sections: [
      {
        label: 'Optionen',
        settings: ['readonlymode']
      },
      {
        label: 'Filter',
        settings: ['channel']
      }
    ]
  }
}

export default WidgetMessenger
